const MAX_ANCILLARIES_TO_SHOW = 2;

export default MAX_ANCILLARIES_TO_SHOW;
